export default __webpack_public_path__ + "static/media/lobby_fourth_image.2ba8883b.jpg";